import Vue from 'vue';
import Router from 'vue-router';
import MapPage from '@/components/pages/MapPage';
import MainWindow from '@/components/pages/MainWindow';
import Disclaimer from '@/components/pages/Disclaimer';
import Faq from '@/components/pages/Faq';
import FaqMobile from '@/components/pages/FaqContent';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  saveScrollPosition: true,
  routes: [
    {
      path: '/',
      component: MainWindow,
      children: [
        {
          path: 'map',
          component: MapPage
        },
        {
          path: 'disclaimer',
          component: Disclaimer
        },
        {
          path: 'faq',
          component: Faq
        },
        {
          path: '',
          redirect: 'map'
        }
      ]
    },
    {
      path: '/faq-mobile',
      component: FaqMobile
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js